import { useState } from 'react';

export const faqs = [
  {
    q: 'How is Penland different from QuickBooks Live or a national bookkeeping firm?',
    a: 'We are not a call center. You work with one dedicated bookkeeper who knows your business, your industry, and your local market. We understand tipped payroll nuances, job costing for contractors, and Virginia-specific tax requirements that national firms simply are not equipped to handle.',
  },
  {
    q: 'What does your monthly bookkeeping service include?',
    a: 'Our core monthly service includes transaction categorization, bank and credit card reconciliation, accounts payable and receivable tracking, monthly financial statements (P&L, Balance Sheet, Cash Flow), and a monthly review call where we walk you through the numbers and flag anything that needs attention.',
  },
  {
    q: 'How much do your services cost?',
    a: 'Pricing depends on transaction volume, number of employees, and complexity. Most restaurant, trades, small business, and nonprofit clients fall in the $400–$1,200/month range for core bookkeeping. We offer custom quotes after a free discovery call — no surprises, no hidden fees.',
  },
  {
    q: 'What accounting software do you use?',
    a: 'We are certified QuickBooks Online ProAdvisors and experienced with Xero. We also integrate directly with industry-specific tools like Toast, Square, ServiceTitan, Housecall Pro, and field service management platforms to keep your data flowing automatically.',
  },
  {
    q: 'Will you work with my CPA for tax preparation?',
    a: 'Absolutely. We design our year-end deliverables to make your CPA\'s job effortless. Clean books, organized documentation, and reconciled accounts mean faster tax prep, fewer questions, and typically lower tax preparation fees.',
  },
  {
    q: 'Do you offer cleanup services for messy books?',
    a: 'Yes. If your current books are behind, miscategorized, or reconciled poorly, we offer a one-time cleanup and catch-up service. We then transition you to ongoing monthly maintenance so you never fall behind again.',
  },
  {
    q: 'Can we meet in person, or is everything virtual?',
    a: 'We are virtual-first for efficiency, but we offer in-person meetings in Richmond, Henrico, and Chesterfield areas. Many clients prefer a mix: virtual for routine work, in-person for quarterly reviews or onboarding.',
  },
  {
    q: 'How quickly can you get started?',
    a: 'Most clients are onboarded within 1–2 weeks of signing. We start with a discovery call, then move to software access, historical review, and chart-of-accounts setup. Complex cleanups may add 2–4 weeks depending on how far behind the books are.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">
              Common Questions
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-950 leading-tight">
              Frequently Asked
              <span className="italic text-accent-600"> Questions</span>
            </h2>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-background-200/30 transition-colors"
                  aria-expanded={openIndex === i}
                >
                  <span className="font-heading text-base md:text-lg text-primary-950 font-semibold pr-4">
                    {faq.q}
                  </span>
                  <div
                    className={`w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center shrink-0 transition-transform ${
                      openIndex === i ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-accent-600" />
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}